module.exports = __webpack_public_path__ + "img/vessel_visitation_3_63021.2a241530.jpg";